export default __webpack_public_path__ + "static/media/soups22-whatsapp.dc04bc12.pdf";